export interface DetailsRow {
  label: string;
  value: number|string|boolean|Array<string|number>;
}

interface Props {
  title: string;
  details: Array<DetailsRow>;
}

export function Details(props: Props) {
  return (
    <div className="Details">
      <h3 className="details-title">{props.title}</h3>
      {props.details.map((row: DetailsRow,index: number) => {
        return (<div className="details-row" key={index}>
            <b>{row.label}</b>
            {['string','number'].includes(typeof row.value) && (<p>{row.value}</p>)}
            {typeof row.value === 'boolean' && (<p>{row.value ? 'Yes': 'No'}</p>)}
            {Array.isArray(row.value) && (<p>{row.value.join(', ')}</p>)}
          </div>
        );
      })}
    </div>
  );
}

